// UI translations for this locale. Keys must match the es reference bundle —
// enforced by `npm run check:i18n` (scripts/check-i18n-parity.mjs).
export const ca = {
  app: { name: 'bitutravel' },
  nav: {
    home: 'Inici',
    search: 'Cercar',
    login: 'Iniciar sessió',
    register: 'Registra\'t',
    dashboard: 'Panell',
    reservas: 'Reserves',
    equipo: 'Equip',
    logout: 'Tancar sessió',
    legal: 'Legal',
    legalNotice: 'Avís legal',
    privacy: 'Política de privacitat',
    cookies: 'Política de cookies',
    terms: 'Termes i condicions',
    clientes: 'Clients',
  },
  legal: {
    noticeTitle: 'Avís legal',
    noticeBody:
      'En compliment de la Llei 34/2002 (LSSI-CE), s\'informa que aquest lloc web és titularitat de bitutravel. Correu de contacte: legal@bitutravel.app. L\'ús del lloc atribueix la condició d\'usuari i implica l\'acceptació d\'aquestes condicions.',
    privacyTitle: 'Política de privacitat',
    privacyBody:
      'Tractem les teves dades únicament per gestionar el teu compte, les teves reserves i la facturació exigida per la normativa espanyola (RGPD i LOPDGDD). Mai cedim les teves dades a tercers amb finalitats comercials. Pots exercir els teus drets d\'accés, rectificació, supressió i portabilitat escrivint a privacy@bitutravel.app.',
    cookiesTitle: 'Política de cookies',
    cookiesBody:
      'bitutravel només utilitza cookies tècniques imprescindibles: la sessió d\'autenticació i la preferència d\'idioma. No fem servir cookies publicitàries ni de seguiment de tercers.',
    termsTitle: 'Termes i condicions',
    termsBody:
      'Les reserves se sol·liciten a través de la plataforma i queden subjectes a l\'aprovació del propietari i a la política de cancel·lació escollida. La facturació corporativa s\'emet conforme a la normativa espanyola (IVA i IRPF aplicables). bitutravel actua com a intermediari entre l\'empresa sol·licitant i el propietari de l\'allotjament. Els preus mostrats no inclouen IVA (21%), que s\'afegeix al total de la reserva.',
  },
  landing: {
    heroTitle: 'Allotjament corporatiu sense complicacions',
    heroSubtitle:
      'Trobeu allotjament de qualitat a mitjà termini per als vostres equips a tota Espanya. Amb la confiança d\'empreses líders.',
    checkIn: 'Entrada',
    checkOut: 'Sortida',
    guests: 'Hostes',
    search: 'Cercar',
    featured: 'Estades destacades',
    featuredIn: 'Destacats a {{city}}',
    guestsValue: '{{count}} hostes',
    where: 'On',
    when: 'Quan',
    who: 'Qui',
    searchDestinations: 'Cercar destinacions',
    addDates: 'Afegeix dates',
    addGuests: 'Afegeix hostes',
    howItWorks: 'Com funciona',
    step1Title: 'Cerca',
    step1Desc: 'Explora allotjaments verificats a les principals ciutats d\'Espanya.',
    step2Title: 'Reserva',
    step2Desc: 'Reserva estades de mitjana durada per als teus equips amb condicions corporatives.',
    step3Title: 'Muda\'t',
    step3Desc: 'El teu equip s\'hi allotja. Nosaltres gestionem la factura i el part de viatger.',
    perNight: '/ nit',
    perNightPlusIva: '/ nit + IVA',
    comingSoon: 'Properament',
    trustedBy: 'Ja confien en nosaltres',
    testimonialsTitle: 'El que diuen els nostres clients',
    review1Text: 'Des que uso bitutravel ens arriben les factures i simplifica tot el procés.',
    review1Author: 'Maria López',
    review1Role: 'Responsable de mobilitat, consultora tecnològica',
    review2Text: 'Gestionem l\'allotjament de tot l\'equip en una sola plataforma. L\'estalvi de temps i costos és evident.',
    review2Author: 'Javier Ruiz',
    review2Role: 'Director d\'operacions, empresa d\'enginyeria',
    review3Text: 'La facturació corporativa i la nota de viatger venen llestos per a auditoria. Zero feina administrativa.',
    review3Author: 'Elena García',
    review3Role: 'Responsable financera, multinacional',
    illustrativeImage: 'imatge il·lustrativa',
  },
  search: {
    allSpain: 'Tota Espanya',
    allDistricts: 'Tots els districtes',
    viewAllResults: 'Veure tots els resultats',
    results: 'resultats',
    sort: 'Ordenar',
    sortPriceAsc: 'Preu: de menor a major',
    sortPriceDesc: 'Preu: de major a menor',
    noResults: 'No hi ha allotjaments en aquesta zona.',
    noResultsForFilters: 'No hi ha allotjaments per a aquests filtres. Prova a treure dates o canviar els filtres.',
    clearFilters: 'Treure filtres',
    areaPlaceholder: 'Barri, zona o codi postal',
    showMap: 'Mapa',
    showMore: 'Veure més',
    backToTop: 'Tornar amunt',
    typeAll: 'Tot',
    placeEntire: 'Apartament sencer',
    placeRoom: 'Habitació',
    placeHotel: 'Hotel',
    dates: 'Dates',
    sortRecommended: 'Recomanat',
    size: 'Dormitoris',
    sizeAny: 'Qualsevol',
    sizeSingle: '1 dormitori',
    sizeDouble: '2 dormitoris',
    size3plus: '3+ dormitoris',
    rooms: 'Habitacions',
    units: 'Unitats',
    grouping: 'Agrupar',
    groupAny: 'Qualsevol',
    typeInCity: '{{type}} a {{city}}',
    forNights: 'per {{count}} nits',
    filters: 'Filtres',
    groupSameBuilding: 'Mateix edifici',
    groupSameArea: 'Zona propera',
    groupSameCategory: 'Mateixa categoria',
    roomsValue: '{{count}} hab.',
    unitsValue: '{{count}} uds.',
    groupResults: 'grups',
    fromPrice: 'des de {{price}}',
    unitsInBuilding: '{{count}} unitats en aquest edifici',
    groupUnits: 'unitats',
    sameBuilding: 'Mateix edifici',
    sameArea: 'Zona propera',
    sameCategory: 'Mateixa categoria',
    anyGroup: 'Unitats',
    priceFrom: 'des de',
    bookAll: 'Reservar les {{count}}',
    playTour: 'Reprodueix el recorregut',
    approxMapNote: 'Les ubicacions són aproximades. Registra\'t per veure la ubicació exacta.',
    pauseTour: 'Pausa el recorregut',
    bookAllTitle: 'Reservar el grup',
    bookAllDesc: 'Reserva les {{count}} unitats com un mateix conjunt.',
    bookAllSummary: '{{count}} unitats · {{nights}} nits',
    bookAllSomeFailed: 'Algunes unitats no s\'han pogut reservar.',
    bookAllDone: 'Conjunt reservat ({{ok}}/{{count}}).',
    structRoomIn: 'Habitació a {{building}}',
    structRoomsSameApartment: '{{count}} habitacions al mateix apartament',
    structRoomsSameBuilding: '{{count}} habitacions al mateix edifici',
    structApartmentsSameBuilding: '{{count}} apartaments al mateix edifici',
    structStaysSameArea: '{{count}} allotjaments a la mateixa zona',
    structStaysSameCategory: '{{count}} allotjaments · {{category}}',
    structUnits: '{{count}} unitats',
    specFull: '{{guests}} hostes · {{bedrooms}} dormitoris · {{baths}} banys',
    specShort: '{{bedrooms}} dorm. · {{baths}} bany',
  },
  detail: {
    guests: 'hostes',
    bedrooms: 'dormitoris',
    bathrooms: 'banys',
    amenities: 'Serveis',
    location: 'Ubicació',
    nights: 'nits',
    cleaningFee: 'Neteja',
    total: 'Total',
    iva: 'IVA ({{pct}}%)',
    ivaNote: 'Preus sense IVA: s\'afegeix el 21% d\'IVA al total de la reserva. Factura corporativa conforme.',
    bookNow: 'Reservar ara',
    loginToBook: 'Inicia la sessió per reservar',
    signInForDetails: 'Inicia la sessió per veure els detalls complets.',
    approxLocation: 'Ubicació aproximada (radi d\'uns 700 m)',
    checkin: 'Entrada',
    checkout: 'Sortida',
    tooManyGuests: 'Aquesta propietat admet fins a {{capacity}} hostes.',
    minStayWarning: 'Estada mínima: {{count}} nit | Estada mínima: {{count}} nits',
    nightsWithCount: '{{count}} nit | {{count}} nits',
  },
  booking: {
    title: 'Reservar ara',
    subtitle: 'Verifica les dades del viatger. L\'import es recàlcula al servidor.',
    confirm: 'Confirmar reserva',
    guestName: 'Nom del viatger',
    guestNamePlaceholder: 'Nom i cognoms',
    guestNif: 'NIF del viatger',
    datesRequired: 'Selecciona dates vàlides',
    nameRequired: 'Introdueix el nom del viatger',
    nifInvalid: 'NIF no vàlid',
    requestCreated: 'Reserva creada. Pendent de pagament.',
    notAvailable: 'Aquestes dates ja no estan disponibles.',
    notApproved: 'El teu compte no està aprovat per reservar.',
    createError: 'No s\'ha pogut crear la reserva. Torna-ho a provar.',
    awaitingDesc: 'Reserva creada. Fes el pagament per confirmar-la.',
    totalWithIva: 'Total (IVA inclòs)',
    priceEstimateNote: 'Preu estimat: bitutravel calcula l\'import final en reservar.',
    total: 'Total',
    reference: 'Referència',
    openPaymentLink: 'Obrir l\'enllaç de pagament',
    mockDevNote:
      'Mode desenvolupament: el pagament és simulat. Pulsa per marcar-lo com a pagat i simular el webhook de Revolut.',
    markPaidDev: 'Marcar com a pagat (dev)',
    markPaidError: 'No s\'ha pogut simular el pagament.',
    paid: 'Pagament confirmat',
    paidDesc: 'La teva reserva està confirmada. Rebràs la factura per correu.',
    viewBookings: 'Veure les meves reserves',
    paymentStatus: 'Pagament',
    bookingsTitle: 'Les meves reserves',
    browseStays: 'Cerca allotjament',
    summaryTotal: 'Reserves',
    summaryUpcoming: 'Pròximes',
    summaryInstay: 'En estada',
    summarySpend: 'Despesa total',
    summaryPendingNote: 'Tens {{count}} reserves pendents de pagament.',
    payStatusPaid: 'Pagat',
    payStatusPending: 'Pendent',
    payStatusAwaiting: 'Pendent de pagament',
    payStatusRefunded: 'Reembolsat',
    payStatusFailed: 'Fallit',
    payStatusScheduled: 'Programat',
    empty: 'Encara no tens reserves.',
    statusAwaitingPayment: 'Pendent de pagament',
    statusConfirmed: 'Confirmada',
    statusActive: 'En curs',
    statusCompleted: 'Completada',
    statusCancelled: 'Cancel·lada',
    statusDisputed: 'En disputa',
    notFound: 'Reserva no trobada.',
    viewProperty: 'Veure la propietat',
    cleaningFee: 'Neteja',
    platformFee: 'Comissió de bitutravel',
    cancelBooking: 'Cancel·lar la reserva',
    cancelConfirm: 'Segur que vols cancel·lar aquesta reserva? Aquesta acció no es pot desfer.',
    cancelConfirmYes: 'Sí, cancel·la-la',
    cancelledToast: 'Reserva cancel·lada.',
    cancelError: 'No s\'ha pogut cancel·lar la reserva.',
    cancelReason: 'Motiu de la cancel·lació',
    copyLink: 'Copiar l\'enllaç',
    tabFuture: 'Pròximes',
    tabPresent: 'En curs',
    tabPast: 'Passades',
    emptyTab: 'No hi ha reserves en aquesta secció.',
    purpose: 'Motiu del viatge',
    purposeLeisure: 'Personal',
    purposeConference: 'Congrés / esdeveniment',
    purposeProject: 'Projecte',
    purposeRelocation: 'Reubicació',
    purposeOther: 'Altre',
    eventName: 'Nom de l\'esdeveniment',
    eventNamePlaceholder: 'Ex. Mobile World Congress 2026',
    teamSize: 'Persones',
    teamNotes: 'Detalls de l\'equip',
    teamNotesPlaceholder: 'Noms dels viatgers, habitació, notes…',
    teamDetails: 'Detall del viatge / equip',
    employee: 'Empleat',
    employeePlaceholder: 'Sense assignar',
    employeeNone: 'Sense empleat',
    employeeFilterAll: 'Tots els empleats',
    employeeCardTitle: 'Empleat assignat',
  },
  team: {
    title: 'Equip',
    addEmployee: 'Afegir empleat',
    intro: 'Gestiona els empleats de la teva empresa. Assigna\'ls a reserves perquè rebin els detalls per email, o activa\'ls perquè facin les seves pròpies reserves a càrrec de l\'empresa.',
    featureRosterTitle: 'Plantilla',
    featureRosterDesc: 'Nom, email, telèfon i NIF de cada empleat. La majoria són recurrents: els reutilitzes a cada reserva.',
    featureEmailTitle: 'Detalls per email',
    featureEmailDesc: 'En fer una reserva, assigna l\'empleat i rep les dades per correu.',
    featureActivateTitle: 'Activa per reservar',
    featureActivateDesc: 'Activa un empleat perquè entri amb el seu email i reservi a càrrec de l\'empresa.',
    empty: 'Encara no hi ha empleats. Aviat podràs afegir-los i assignar-los a les teves reserves.',
    editEmployee: 'Editar empleat',
    editDesc: 'Modifica les dades de contacte de l\'empleat.',
    addDesc: 'Afegeix un empleat i activa\'l perquè entri amb el seu propi email.',
    addNote: 'S\'afegirà a la fitxa d\'empleats. Perquè entri amb el seu correu, activa el seu accés després.',
    activateLogin: 'Activar accés',
    alreadyActivated: 'Aquest empleat ja té l\'accés activat.',
    platformUnavailable: 'El servei no està disponible ara. Prova-ho més tard.',
    phone: 'Telèfon',
    updated: 'Empleat actualitzat.',
    added: 'Empleat afegit.',
    emailExists: 'Ja existeix un empleat amb aquest email.',
    activated: 'Empleat activat.',
    deactivated: 'Empleat desactivat.',
    deleted: 'Empleat eliminat.',
    activate: 'Activar',
    deactivate: 'Desactivar',
    delete: 'Eliminar',
    deleteTitle: 'Eliminar empleat',
    deleteConfirm: 'Segur que vols eliminar {{name}}? Se n\'esborrarà el compte i no es podrà desfer.',
    statusActive: 'Actiu',
    statusInactive: 'Inactiu',
    statusRoster: 'Només fitxa',
    tempPwTitle: 'Contrasenya temporal',
    tempPwDesc: 'Aquesta és la contrasenya temporal de {{name}}. Comparteix-la amb la persona de forma segura.',
    tempPwWarn: 'No es tornarà a mostrar. Copia-la ara.',
    copy: 'Copiar',
    copied: 'Copiat',
  },
  agency: {
    title: 'Clients',
    intro: 'Gestiona les empreses client de la teva agència. Afegeix-les amb el seu email de facturació i reserva viatges al seu nom: la factura va a l\'empresa client.',
    addClient: 'Afegir empresa client',
    clientEmail: 'Email de facturació de l\'empresa',
    clientEmailPlaceholder: 'factures@empresa.es',
    addNote: 'L\'empresa ha de tenir compte a bitutravel i estar aprovada. Es validarà en enllaçar-la.',
    empty: 'Encara no tens empreses client. Afegeix-ne per començar a reservar al seu nom.',
    client: 'Client',
    unknownClient: 'Empresa client',
    unlinkConfirm: 'Segur que vols desvincular {{name}}? Ja no podràs reservar al seu nom.',
    unlinkedBtn: 'Desvincular',
    unlinked: 'Empresa client desvinculada.',
    linked: 'Empresa client vinculada: {{name}}.',
    notFound: 'No es va trobar cap empresa aprovada amb aquest email.',
    billTo: 'Reservar per a',
    selectClient: 'Selecciona una empresa client',
    noClientsWarn: 'Afegeix primer una empresa client a Clients per poder reservar.',
  },

  invoices: {
    title: 'Factures i parts',
    backToBookings: '← Les meves reserves',
    count: 'Factures',
    baseTotal: 'Base imposable',
    ivaTotal: 'IVA',
    irpfTotal: 'IRPF retingut',
    total: 'Total facturat',
    invoicesTitle: 'Factures',
    ref: 'Reserva',
    parteTitle: 'Parts de viatger',
    parteEmpty: 'Encara no hi ha parts de viatger.',
    empty: 'Encara no tens factures. Es generen automàticament en confirmar una reserva.',
    regenTitle: 'Reemetre documents',
    regenDesc: 'Regenera la factura i el part de viatger d\'una reserva (útil per a la comptabilitat).',
    regenDone: 'Documents regenerats.',
    regenError: 'No s\'han pogut regenerar els documents.',
    downloadError: 'No s\'ha pogut descarregar el document.',
    navInvoices: 'Factures',
    period30: 'Últims 30 dies',
    period90: 'Últims 90 dies',
    period365: 'Últims 12 mesos',
    periodAll: 'Tot l\'historial',
    periodEmpty: 'No hi ha factures en aquest període.',
    exportCsv: 'Exportar CSV',
    exportZip: 'Descarregar PDF (ZIP)',
    statusIssued: 'Emitida',
    statusPaid: 'Pagada',
    statusVoid: 'Anul·lada',
  },
  owner: {
    calendar: {
      title: 'Calendari de tarifes',
      subtitle: 'Preu, estada mínima i disponibilitat nit a nit',
      navButton: 'Tarifes',
      backendRequired: 'Configura el backend de Supabase per fer servir el calendari de tarifes.',
      basePrice: 'Tarifa base',
      cleaningFee: 'Neteja',
      applyTitle: 'Aplica a la selecció',
      clearSelection: 'Treure la selecció',
      selectHint: 'Fes clic en una nit i després en una altra per triar un rang. Cada casella és una nit: l’última marcada és la nit anterior a la sortida.',
      selectedNights: '{{count}} nit seleccionada | {{count}} nits seleccionades',
      skipped: '{{count}} nit omesa (reservada o passada) | {{count}} nits omeses (reservades o passades)',
      noneEditable: 'Totes les nits seleccionades estan reservades o ja han passat.',
      priceLabel: 'Nou preu (€)',
      pricePlaceholder: '€ / nit',
      minNightsLabel: 'Estada mínima (nits)',
      minNightsPlaceholder: 'p. ex. 5',
      applyPrice: 'Fixa el preu',
      applyMinNights: 'Fixa la mínima',
      block: 'Bloqueja',
      unblock: 'Obre',
      removeOverride: 'Treu la personalització',
      blockNameLabel: 'Nom del bloc',
      blockNamePlaceholder: 'p. ex. Manteniment, Obres…',
      saved: 'Calendari actualitzat',
      saveError: 'No s’ha pogut desar el calendari.',
      legend: {
        available: 'Disponible',
        priced: 'Preu personalitzat',
        blocked: 'Bloquejada',
        booked: 'Reservada',
        past: 'Passada',
        sunday: 'Diumenge',
      },
      ical: {
        title: 'Exporta el calendari (iCal)',
        desc: 'Connecta aquest feed amb Airbnb, Booking.com o el teu channel manager per sincronitzar les reserves.',
        copy: 'Copia',
        copied: 'Enllaç copiat',
        unavailable: 'Feed no disponible per a aquesta propietat.',
      },
      bulk: {
        from: 'Des de',
        to: 'fins a',
        allDays: 'Tots els dies',
        weekdays: 'Entre setmana',
        weekends: 'Cap de setmana',
        allYear: 'Tot l’any',
        pickDay: 'Tria almenys un dia de la setmana',
      },
    },
    revenueTitle: 'Ingressos',
    invoicesTitle: 'Factures i cobraments',
    invoicesNote: 'Les factures es generen automàticament en confirmar una reserva; els pagaments es liquiden segons el calendari de bitutravel.',
    gross: 'Base (sense IVA)',
    fee: 'Comissió de bitutravel',
    iva: 'IVA',
    net: 'Ingrés net',
    paidOut: 'Pagat',
    pending: 'Pendent de pagament',
    monthlyTitle: 'Ingressos per mes',
    perPropertyTitle: 'Per propietat',
    property: 'Propietat',
    bookings: 'Reserves',
    nights: 'Nits',
    payoutsTitle: 'Pagaments al propietari',
    eligibleDesc: 'Reserves confirmades a punt per pagar:',
    payNow: 'Pagar',
    scheduled: 'Programat',
    noPayouts: 'Encara no hi ha pagaments.',
    noData: 'Encara no hi ha dades.',
    payoutDone: 'Pagament emès.',
    payoutError: 'No s\'ha pogut emetre el pagament.',
    range7: '7 d',
    range15: '15 d',
    range30: '30 d',
    range90: '90 d',
    range12m: '12 m',
    rangeAll: 'Tot',
    payoutConfirmTitle: 'Confirmar pagament',
    payoutConfirmDesc: 'Emetre el pagament de la reserva #{{id}} per {{amount}}?',
    confirm: 'Confirmar',
    propertiesNav: 'Calendari',
    propertiesTitle: 'Calendari',
    newProperty: 'Afegir propietat',
    editProperty: 'Editar',
    propertyUntitled: 'Propietat sense títol',
    propertiesEmpty: 'Encara no has publicat cap propietat.',
    pendingReviewNote: 'Les propietats noves queden en revisió fins que l\'equip de bitutravel les aprovi. T\'avisarem per correu.',
    pendingEditorNote: 'Aquesta propietat està en revisió. La podràs editar; apareixerà a la cerca quan sigui aprovada.',
    unpublished: 'No publicada',
    photoCount: '{{count}} fotos',
    noPhotos: 'Sense fotos',
    unitCount: '{{count}} unitats',
    viewCalendar: 'Calendari',
    viewList: 'Llista',
    searchUnits: 'Cerca unitats…',
    sortName: 'Nom',
    sortRecent: 'Recents',
    chipNeedsPhotos: 'Sense fotos',
    stripNoBookings: 'Sense reserves els propers 30 dies',
    pms: {
      title: 'Gestor de reserves',
      subtitle: 'Reserves per unitat — arrossega per moure',
      prev: 'Anterior',
      next: 'Següent',
      today: 'Avui',
      view_month: 'Mes',
      view_week: 'Setmana',
      dragHint: "Arrossega una reserva a una altra unitat o data per moure-la.",
      moved: 'Reserva moguda',
      moveError: "No s'ha pogut moure la reserva",
      noCity: 'Sense ciutat',
      cities: 'Ciutats',
      properties: 'Propietats',
      unit: 'Unitat',
      overall: 'Vista general',
      allProperties: 'Totes les propietats',
      noUnits: 'Encara no tens unitats. Afegeix una propietat per començar.',
      guest: 'Hoste',
      dragHintBlocked: "Haz clic en un día vacío para bloquearlo / abrirlo. Arrastra una reserva para moverla; arrastra su borde derecho para ampliar o acortar.",
      addBooking: "Añadir reserva",
      dates: 'Dates',
      autoRate: 'Tarifa automàtica',
      applyCustomPrice: 'Aplicar preu personalitzat (descompte)',
      customPriceHint: 'Edita el total per aplicar un descompte. Es reparteix entre les nits.',
      manualBooking: "Reserva manual",
      manualBadge: "Manual",
      guestName: "Nombre del huésped",
      guestNif: "NIF del huésped",
      guests: "Huéspedes",
      pricePerNight: "Preu per nit",
      checkin: "Entrada",
      checkout: "Salida",
      block: "Bloquear",
      unblock: "Abrir",
      blocked: "Bloqueado",
      blockTitle: 'Bloquejar nit',
      blockNameLabel: 'Nom (opcional)',
      blockNamePlaceholder: 'p. ex. Manteniment',
      blockNameHint: 'Es mostrarà al dia bloquejat.',
      blockConfirm: 'Bloquejar',
      manualCreated: "Reserva manual creada",
      manualError: "No se pudo crear la reserva manual",
      notAvailable: "No disponible para esas fechas",
      belowMinStay: "Por debajo de la estancia mínima de esta unidad",
      detail: "Detalle de la reserva",
      property: "Propiedad",
      nights: "Noches",
      total: "Total",
      iva: "IVA",
      fee: "Comisión de la plataforma",
      payout: "Pago",
      channel: "Canal",
      status: "Estado",
      statusConfirmed: "Confirmada",
      statusActive: "En estancia",
      statusPending: "Pendiente",
      statusAwaiting: "Pendiente de pago",
      statusCancelled: "Cancelada",
      channelManual: "Manual",
      channelDirect: "Directo",
      channelIcal: "iCal (importat)",
      icalNoPayout: "Bloqueig extern — sense pagament",
      confirmMove: "Confirmar movimiento",
      moveFrom: "Desde",
      moveTo: "Hasta",
      moveNote: "La disponibilidad y el precio se revalidan al confirmar.",
      confirm: "Confirmar",
      extendTitle: "Ampliar estancia",
      shortenTitle: "Acortar estancia",
      newCheckout: "Nueva salida",
      extended: "Estancia actualizada",
      extendError: "No se pudo actualizar la estancia",
    },
    products: {
      nav: 'Propietats',
      title: 'Propietats',
      subtitle: 'Tarifes i canals per unitat. La tarifa per defecte se sincronitza amb el preu de la propietat.',
      empty: 'Encara no tens propietats.',
      ratePlans: 'Tarifes',
      addRatePlan: 'Afegir tarifa',
      editRatePlan: 'Editar tarifa',
      ratePlanDesc: 'Una tarifa és una oferta venible d’aquesta unitat (preu, neteja, estada mínima).',
      noPlans: 'Sense tarifes encara.',
      planCount: '{{count}} tarifes',
      icalCount: '{{count}} iCal',
      default: 'Per defecte',
      inactive: 'Inactiva',
      minNights: 'mín. {{count}} nits',
      minNightsLabel: 'Nits mínimes',
      feePct: 'comissió {{pct}}%',
      feePctLabel: 'Comissió bitutravel (%)',
      feePctPlaceholder: 'predeterminada',
      feePctHint: 'Buit = comissió global. 0 = client propi (sense comissió).',
      makeDefault: 'Tarifa per defecte',
      name: 'Nom',
      basePrice: 'Preu base (NET)',
      cleaningFee: 'Neteja',
      cancellation: 'Cancel·lació',
      policy: {
        flexible: 'Flexible',
        moderate: 'Moderada',
        strict: 'Estricta',
      },
      save: 'Guardar',
      cancel: 'Cancel·lar',
      edit: 'Editar',
      delete: 'Eliminar',
      confirmDelete: 'Eliminar?',
      defaultNoDelete: 'No es pot eliminar la tarifa per defecte.',
      created: 'Tarifa creada.',
      updated: 'Tarifa actualitzada.',
      deleted: 'Tarifa eliminada.',
      channels: 'Canals',
      addChannel: 'Afegir canal',
      direct: 'Directe',
      noConnections: 'Sense connexions. Afegeix un canal iCal per importar un calendari extern.',
      icalChannel: 'iCal',
      addIcal: 'Afegir connexió iCal',
      icalDesc: 'Enganxa la URL iCal d’un calendari extern (Airbnb, Booking, Google…). Les dates reservades bloquejaran aquesta unitat.',
      icalUrl: 'URL del calendari iCal',
      addAndSync: 'Afegir i sincronitzar',
      syncNow: 'Sincronitzar',
      syncAll: 'Sincronitzar-ho tot',
      syncDone: '{{upserted}} importades, {{cancelled}} cancel·lades, {{conflicts}} conflictes',
      syncAllDone: 'Sincronització completa: {{upserted}} importades, {{cancelled}} cancel·lades, {{conflicts}} conflictes',
      syncError: 'Error de sincronització',
      lastSync: 'Última sincronització',
      neverSynced: 'Sense sincronitzar encara',
      connectionDeleted: 'Connexió eliminada.',
      connStatus: {
        pending: 'Pendent',
        active: 'Activa',
        paused: 'Pausada',
        error: 'Error',
      },
      rangeActionTitle: 'Rang seleccionat',
      rangeActionHint: 'Què vols fer amb aquestes nits?',
      selectHint: 'Fes clic en una nit i després en una altra (o dues vegades en la mateixa) per triar un rang.',
    },

    status: {
      pending: 'En revisió',
      approved: 'Publicat',
      rejected: 'Rebutjada',
    },
    step1: 'Dades',
    step2: 'Descripció',
    step3: 'Ubicació i fotos',
    backStep: 'Enrere',
    nextStep: 'Següent',
    saveProperty: 'Guardar la propietat',
    fieldType: 'Tipus d\'allotjament',
    type: {
      apartment: 'Apartament',
      studio: 'Estudi',
      house: 'Casa',
      room: 'Habitació',
      loft: 'Loft',
      duplex: 'Dúplex',
      cabin: 'Cabanya',
      guesthouse: 'Casa de hostes',
      hotel: 'Hotel',
      bed_breakfast: 'Casa rural',
    },
    fieldCapacity: 'Capacitat (hostes)',
    fieldBeds: 'Llits',
    fieldPrice: 'Preu per nit (€)',
    fieldCleaning: 'Tarifa de neteja (€)',
    fieldCheckinTime: "Hora d'entrada",
    fieldCheckoutTime: 'Hora de sortida',
    fieldTitleEs: 'Títol (espanyol)',
    fieldTitleEn: 'Títol (anglès)',
    fieldDescEs: 'Descripció (espanyol)',
    fieldDescEn: 'Descripció (anglès)',
    fieldCity: 'Ciutat',
    fieldCategory: 'Categoria',
    fieldCategoryHint: 'executiva, estàndard, suite…',
    fieldBuilding: 'Edifici / adreça',
    fieldUnitLabel: 'Etiqueta de la unitat',
    fieldNeighborhood: 'Barri / districte',
    fieldNeighborhoodHint: 'p. ex. Chamberí',
    fieldPostalCode: 'Codi postal',
    cityPrefillNote: 'En triar la ciutat, omplim les coordenades amb el centre; ajusta-les si coneixes la ubicació exacta.',
    photosAfterCreate: 'Guarda la propietat per poder afegir fotos.',
    addPhotos: 'Afegir fotos',
    deletePhoto: 'Eliminar foto',
    photoUploadError: 'No s\'ha pogut pujar la foto.',
    photoDeleteError: 'No s\'ha pogut eliminar la foto.',
    createdToast: 'Propietat creada. Està en revisió.',
    savedToast: 'Propietat guardada.',
    saveError: 'No s\'ha pogut guardar la propietat.',
    fiscal: {
      title: 'Dades fiscals i VeriFactu',
      subtitle: "Informació de l'emissor i autorització perquè bitutravel tramiti les teves factures a l'AEAT.",
      statusActive: "VeriFactu actiu. Les teves factures d'allotjament es tramiten a l'AEAT.",
      statusPending: "VeriFactu pendent. Les teves factures s'emeten però no es tramiten a l'AEAT.",
      statusRevoked: "La teva autorització ha estat revocada. La tramitació a l'AEAT està en pausa.",
      active: 'Actiu',
      pending: 'Pendent',
      revoked: 'Revocat',
      issuerTitle: "Dades de l'emissor",
      personaType: 'Tipus de persona',
      personaF: 'Física',
      personaJ: 'Jurídica',
      seriesLodging: 'Sèrie de factures',
      seriesHint: "Sèrie AEAT per a les teves factures d'allotjament (per defecte O). No la canviïs sense motiu.",
      legalName: 'Raó social / Nom',
      nif: 'NIF',
      country: 'País',
      street: 'Adreça',
      postalCode: 'Codi postal',
      city: 'Població',
      save: 'Desa les dades fiscals',
      saved: 'Dades fiscals desades.',
      saveError: "No s'han pogut desar les dades fiscals.",
      errFields: 'La raó social i el NIF són obligatoris.',
      apoderamientoTitle: 'Apoderament',
      apoderamientoDesc: "Per tramitar factures a l'AEAT en nom teu, bitutravel necessita un poder de representació signat. Puja el poder signat per activar la tramitació.",
      poderOnFile: 'Poder registrat:',
      uploadPoder: 'Pujar poder signat (PDF)',
      poderHint: 'PDF, màx. 10 MB.',
      granted: 'Apoderament activat. VeriFactu tramitarà les teves pròximes factures.',
      grantError: "No s'ha pogut registrar el poder.",
      errPoderSize: 'El fitxer supera els 10 MB.',
      legalNote: "Pujant el poder confirmes que has signat l'autorització de representació perquè bitutravel tramiti factures a l'AEAT (RD 1007/2023).",
      bannerPending: "Activa VeriFactu per tramitar les teves factures a l'AEAT.",
      bannerRevoked: 'La teva autorització VeriFactu està revocada.',
      bannerCta: 'Configura',
    },

  },
  profile: {
    title: 'Perfil i ajustos',
    navProfile: 'Perfil',
    accountSection: 'Compte',
    statusLabel: 'Estat del compte',
    rejectionReason: 'Motiu del rebuig',
    detailsSection: 'Dades fiscals',
    languageSection: 'Idioma',
    localeLabel: 'Idioma preferit',
    localeHint: 'Es guarda al teu compte i s\'aplica a tots els teus dispositius.',
    localeSaved: 'Idioma actualitzat.',
    billingSection: 'Facturació i pagament',
    invoiceEmail: 'Email de facturació',
    invoiceEmailPlaceholder: 'factures@teuempresa.es',
    ibanTransfer: 'IBAN (pagament per transferència)',
    ibanHint: 'Si prefereixes pagar per transferència bancària.',
    preferredMethod: 'Mètode de pagament preferit',
    methodCard: 'Targeta',
    methodTransfer: 'Transferència',
    savedCards: 'Targetes guardades',
    defaultCard: 'Predeterminada',
    billingProcessorNote: 'Les dades de la targeta es tokenitzen amb Revolut; mai no emmagatzemem el número complet.',
    billingSaved: 'Facturació actualitzada.',
  },
  auth: {
    registerTitle: 'Crear compte',
    loginTitle: 'Iniciar sessió',
    rolePrompt: 'Com faràs servir bitutravel?',
    roleBook: 'Reservo estades',
    roleList: 'Publico propietats',
    roleCompany: 'Empresa',
    roleAutonomo: 'Autònom',
    roleOwner: 'Propietari',
    roleEmployeeLabel: 'Empleat',
    roleAgencyLabel: 'Agència',
    roleCompanyDesc: 'Reserves centralitzades per a la vostra empresa',
    roleAutonomoDesc: 'Per a professionals autònoms',
    roleOwnerDesc: 'Per a publicar i monetitzar les teves propietats',
    roleBookerPrompt: 'Qui reserva?',
    pathManager: 'Gestiono propietats',
    pathManagerDesc: 'Publica el teu inventari i gestiona tarifes i disponibilitat',
    pathBook: 'Reservo estades',
    pathBookDesc: 'Per a empresas, treballadors i autònoms que s’hi allotgen',
    roleEmployee: 'Treballo en una empresa',
    roleEmployeeDesc: 'Reservo amb la targeta de la meva empresa; la factura va per a ella',
    contactName: 'Persona de contacte',
    email: 'Correu electrònic',
    fullName: 'Nom complet',
    legalName: 'Raó social',
    cif: 'CIF',
    nif: 'NIF / DNI',
    address: 'Adreça',
    iban: 'IBAN per a cobraments',
    irpf: 'Retenció IRPF (%)',
    submit: 'Enviar sol·licitud',
    pendingTitle: 'Sol·licitud en revisió',
    pendingDesc: 'El nostre equip està verificant el teu compte. T\'avisarem per correu quan sigui aprovat.',
    pendingApproved: 'El teu compte ha estat aprovat!',
    checkStatus: 'Comprovar de nou',
    profileErrorTitle: 'No hem pogut carregar el teu perfil',
    profileErrorDesc:
      'La teva sessió és vàlida, però no trobem les dades del teu compte. Torna-ho a provar o tanca la sessió.',
    rejectedTitle: 'Sol·licitud rebutjada',
    rejectedDesc: 'La teva sol·licitud no ha estat aprovada. Motiu: {{reason}}',
    loginPrompt: 'Ja tens compte? Inicia la sessió',
    registerPrompt: 'No tens compte? Registra\'t',
    login: 'Iniciar sessió',
    magicLink: 'Enviar l\'enllaç màgic',
    magicLinkSent:
      'T\'hem enviat un enllaç màgic al teu correu. Obre\'l per iniciar la sessió.',
    cifInvalid: 'CIF no vàlid',
    cifInRegistry: 'Trobada al directori',
    nifOrCifInvalid: 'NIF/CIF no vàlid',
    ibanInvalid: 'IBAN no vàlid',
    irpfRange: 'Ha d\'estar entre 7 i 45 %',
    loginErrorGeneric: 'No s\'ha pogut iniciar la sessió. Revisa el correu.',
    loginRateLimited: 'Massa intents. Espera un minut.',
    loginEmailNotConfirmed: 'Confirma el teu correu abans d\'iniciar la sessió.',
  },
  admin: {
    approvalsTitle: 'Cua d\'aprovacions',
    approve: 'Aprovar',
    reject: 'Rebutjar',
    reason: 'Motiu',
    empty: 'No hi ha sol·licituds pendents',
    typeCompany: 'Empresa',
    typeAutonomo: 'Autònom',
    typeOwner: 'Propietari',
    approvedToast: 'Sol·licitud aprovada',
    rejectedToast: 'Sol·licitud rebutjada',
    decisionFailed: 'No s\'ha pogut guardar la decisió',
    searchPlaceholder: 'Cercar per nom, correu o NIF/CIF',
    tabAll: 'Totes',
    tabCompany: 'Empreses',
    tabAutonomo: 'Autònoms',
    tabOwner: 'Propietaris',
    confirmApprove: 'Aprovar {{name}}?',
    confirmReject: 'Rebutjar {{name}}?',
    confirm: 'Confirmar',
    reasonRequired: 'Indica el motiu del rebuig',
    noMatches: 'Sense resultats',
    roleAdmin: 'Administració',
    consoleTitle: "Consola d'administració",
    navApprovals: 'Aprovacions',
    navAccounts: 'Comptes',
    navBookings: 'Reserves',
    navInvoices: 'Factures',
    tabAgency: 'Agències',
    tabEmployee: 'Empleats',
    tabBlocked: 'Bloquejats',
    typeAgency: 'Agència',
    typeEmployee: 'Empleat',
    typeAdmin: 'Administrador',
    typeSuperadmin: 'Superadmin',
    statusPending: 'Pendent',
    active: 'Actiu',
    blocked: 'Bloquejat',
    rejected: 'Rebutjat',
    block: 'Bloquejar',
    unblock: 'Desbloquejar',
    blockedToast: 'Compte bloquejada',
    unblockedToast: 'Compte desbloquejada',
    manageFailed: "No s'ha pogut canviar l'estat del compte",
    commissionDefault: 'Per defecte {{pct}}%',
    commissionEdit: 'Editar',
    commissionSave: 'Guardar',
    commissionCancel: 'Cancel·lar',
    commissionSaved: 'Comissió actualitzada.',
    commissionFailed: "No s'ha pogut actualitzar la comissió.",
    lastActions: "{{count}} accions d'administració registrades",
    noBookings: 'No hi ha reserves.',
    noInvoices: 'No hi ha factures.',
    kindCommission: 'Comissió',
    kindLodging: 'Allotjament',
    vfFiled: 'VeriFactu tramitada',
    vfIncidence: 'Incidència',
    vfPending: 'VeriFactu pendent',
    navRegistry: 'Directori',
    vfSubmit: 'Enviar a AEAT',
    vfSubmitted: 'Enviada a AEAT',
    vfSubmitFailed: 'No s\'ha pogut enviar a AEAT',
    vfNotConfigured: 'Certificat VeriFactu no configurat',
    void: 'Anul·lar',
    voidConfirm: 'Anul·lar aquesta factura? Si va ser enviada a AEAT, s\'enviarà una anul·lació.',
    voidDone: 'Factura anul·lada',
    voidFailed: 'No s\'ha pogut anul·lar la factura',
    voidAnulacionPending: 'Anul·lació AEAT pendent de certificat',
    voided: 'Anul·lada',
    rect: 'Rectificativa',
    rectConfirm: 'Emitir una rectificativa que substitueixi aquesta factura?',
    rectDone: 'Rectificativa emesa',
    rectFailed: 'No s\'ha pogut emetre la rectificativa',
    registry: {
      addTitle: 'Afegir empresa',
      editTitle: 'Editar empresa',
      listTitle: 'Directori d\'empreses',
      cif: 'CIF',
      legalName: 'Raó social',
      street: 'Carrer',
      postalCode: 'Codi postal',
      city: 'Ciutat',
      province: 'Província',
      country: 'País',
      save: 'Desar',
      saved: 'Empresa desada',
      saveError: 'No s\'ha pogut desar l\'empresa',
      deleted: 'Empresa eliminada',
      deleteError: 'No s\'ha pogut eliminar l\'empresa',
      errFields: 'El CIF i la raó social són obligatoris',
      empty: 'Encara no hi ha empreses al directori',
      edit: 'Editar',
    },
  },
  dashboard: {
    roleLabel: 'Rol',
    emailLabel: 'Correu',
  },
  notFound: {
    title: 'Pàgina no trobada',
    desc: 'La pàgina que busques no existeix o ha canviat d\'adreça.',
  },
  error: {
    boundaryDesc: 'Alguna cosa ha fallat. Recarrega per continuar.',
    boundaryReload: 'Recarregar',
  },
  common: {
    loading: 'Carregant…',
    error: 'Alguna cosa ha fallat',
    favorite: 'Desa als preferits',
    required: 'Obligatori',
    back: 'Tornar',
    retry: 'Reintentar',
    continue: 'Continuar',
    done: 'Fet',
    save: 'Guardar',
    plusIva: '+ IVA',
    cancel: 'Cancel·lar',
    rooms: 'habitacions',
    room: 'habitació',
    bathrooms: 'banys',
    bathroom: 'bany',
    increment: 'Augmentar',
    decrement: 'Reduir',
    edit: 'Editar',
    close: "Cerrar",
    previous: 'Anterior',
    next: 'Següent',
  },
  amenities: {
    wifi: 'Wifi',
    parking: 'Aparcament',
    ac: 'Aire condicionat',
    heating: 'Calefacció',
    washing: 'Rentadora',
    dishwasher: 'Rentaplats',
    elevator: 'Ascensor',
    furnished: 'Moblat',
    kitchen: 'Cuina',
    meeting_room: 'Sala de reunions',
    printer: 'Impressora',
    gym: 'Gimnàs',
  },
} as const